import { render, staticRenderFns } from "./CreateModal.vue?vue&type=template&id=45b45a83&scoped=true"
import script from "./CreateModal.vue?vue&type=script&lang=js"
export * from "./CreateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b45a83",
  null
  
)

export default component.exports